export default __webpack_public_path__ + "static/media/522.4385e79f.png";